/**
 * CargasEmRotaWidget — Cargas saindo / em rota.
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarCargas } from "../../../services/logistica";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "cargas_em_rota",
  label: "Cargas em rota",
  descricao: "Cargas atualmente em rota ou aguardando carregamento.",
  categoria: "Logistica",
  permissoes: ["logistica:view"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const emRota = await listarCargas(request, { situacao: "EM_ROTA", pageSize: 1 });
  const carregando = await listarCargas(request, { situacao: "CARREGANDO", pageSize: 1 });
  const c1 = Array.isArray(emRota) ? emRota.length : (emRota?.count ?? (emRota?.results || []).length);
  const c2 = Array.isArray(carregando) ? carregando.length : (carregando?.count ?? (carregando?.results || []).length);
  return { em_rota: c1, carregando: c2 };
}

export function Widget({ dados }) {
  const r = dados?.em_rota ?? 0;
  const c = dados?.carregando ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor>{r}</KpiValor>
        <KpiSub>
          em rota{c > 0 ? ` + ${c} carregando` : ""}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/logistica/cargas">Ver cargas</LinkLight>
      </CardFooter>
    </>
  );
}
